import { DropDownItem } from "../../forms/forms";

export class OrderBy {
  selectedOrderBy: string;
  options: DropDownItem[] = [
    {
      label: "Relevance",
      value: null,
      action: () => {
        this.selectedOrderBy = null;
      },
    },
    {
      label: "Price: low to high",
      value: "rentalRate asc",
      action: () => {
        this.selectedOrderBy = "rentalRate asc";
      },
    },
    {
      label: "Price: high to low",
      value: "rentalRate desc",
      action: () => {
        this.selectedOrderBy = "rentalRate desc";
      },
    },
    {
      label: "Hours: low to high",
      value: "hours asc",
      action: () => {
        this.selectedOrderBy = "hours asc";
      },
    },
    {
      label: "Hours: high to low",
      value: "hours desc",
      action: () => {
        this.selectedOrderBy = "hours desc";
      },
    },
    {
      label: "Year: newest to oldest",
      value: "year desc",
      action: () => {
        this.selectedOrderBy = "year desc";
      },
    },
    {
      label: "Year: oldest to newest",
      value: "year asc",
      action: () => {
        this.selectedOrderBy = "year asc";
      },
    },
  ] as DropDownItem[];

  constructor() {
    const urlParams = new URLSearchParams(window.location.search);
    this.selectedOrderBy = urlParams.get("orderBy");
  }

  getFromQueryParam() {
    const urlParams = new URLSearchParams(window.location.search);
    this.selectedOrderBy = urlParams.get("orderBy");
    return this.selectedOrderBy;
  }

  clear() {
    this.selectedOrderBy = null;
  }
}
